import { useState, MouseEvent } from 'react';
import { ButtonGroup, Icon, IconButton, Popover, Box } from '@mui/material';

type Props = {
    onCommand: (command: string, argument?: string) => void;
};

const ColorButton = ({ onCommand }: Props) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedColor, setSelectedColor] = useState<string>('rgba(231, 227, 252, 0.87)'); // Default color is black

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const color = event.target.value;
        setSelectedColor(color);
        onCommand('forecolor', color); // Apply the selected color
        handleClose(); // Optionally close after color selection
    };

    const open = Boolean(anchorEl);
    const id = open ? 'color-popover' : undefined;

    return (
        <>
            <ButtonGroup disableElevation color="inherit" variant="contained" size="small">
                <IconButton title="Text Color" color="inherit" style={{ color: selectedColor }}>
                    <Icon>format_color_text</Icon>

                    {/* Hidden color input tied to the IconButton */}
                    <input
                        type="color"
                        value={selectedColor}
                        onChange={handleColorChange}
                        style={{
                            opacity: 0,
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            cursor: 'pointer',
                        }}
                    />
                </IconButton>
            </ButtonGroup>
        </>
    );
};

export default ColorButton;
